import { render, staticRenderFns } from "./PercentagePie.vue?vue&type=template&id=53bba559&scoped=true"
import script from "./PercentagePie.vue?vue&type=script&lang=js"
export * from "./PercentagePie.vue?vue&type=script&lang=js"
import style0 from "./PercentagePie.vue?vue&type=style&index=0&id=53bba559&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bba559",
  null
  
)

export default component.exports